<template>
    <v-card>
        <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="total"
            :loading="loading"
            class="elevation-0 dataTable pt-3"
        >
            <template v-slot:body.prepend="{ headers }">
                <tr>
                    <td>
                        <v-text-field
                            v-model="hotelName"
                            label="Hotel..."
                            single-line
                            hide-details
                            v-on:keyup.enter="getData()"
                        >
                        </v-text-field>
                    </td>
                    <td>
                        <v-text-field
                            v-model="hotelCity"
                            label="Cidade"
                            single-line
                            hide-details
                            v-on:keyup.enter="getData()">
                        </v-text-field>
                    </td>
                    <td class="col-2">
                        <v-text-field
                            v-model="hotelState"
                            label="Estado"
                            single-line
                            hide-details
                            v-on:keyup.enter="getData()"
                        >
                        </v-text-field>
                    </td>
                    <td>
                        <v-menu
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="date"
                                    label="Data"
                                    persistent-hint
                                    hide-details="auto"
                                    prepend-icon="mdi-calendar"
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="dateCalendar"
                                range
                                no-title
                            ></v-date-picker>
                        </v-menu>
                    </td>
                    <td></td>
                    <td class="text-center">
                        <v-btn
                            color="primary"
                            width="80%"
                            class="mt-4"
                            depressed
                            @click="getData"
                        >
                            <v-icon size="16px" class="pe-2">mdi-magnify</v-icon>
                            Filtrar
                        </v-btn>
                        <v-btn
                            depressed
                            color="warning"
                            class="my-4"
                            width="80%"
                            @click="getCleanFilter"
                        >
                            <v-icon size="16px" class="pe-2">mdi-close</v-icon>
                            Limpar
                        </v-btn>
                    </td>
                </tr>
            </template>
            <template v-slot:item.created_at="{ item }">
                {{ parseDate(item.created_at, 'DD/MM/YYYY H:mm') }}
            </template>
            <template v-slot:item.updated_at="{ item }">
                {{ getLastUpdateDate(item) }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-container v-if="item.pending_approval" class="pa-0 ma-0 text-center">
                    <v-btn color="success" small
                           :to="{name: 'editHotel', params: { id: item.id }, query: { approveForm: true }}"
                    >Revisar
                    </v-btn>
                </v-container>
                <v-container v-if="!item.is_cnpj_validated" class="pa-0 ma-0 text-center">
                    <v-btn
                        v-if="canValidateCnpj"
                        color="success"
                        small
                        @click="validateHotelCnpj(item)"
                        :loading="item.loading"
                    >
                        Validar CNPJ
                    </v-btn>
                    <router-link :to="{name: 'editHotel', params: {id: item.id}}">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    v-on="on"
                                    color="success"
                                    small
                                    :loading="item.loading"
                                >
                                    <v-icon size="small">mdi-pencil</v-icon>
                                </v-btn>
                            </template>
                            <span>Editar Hotel</span>
                        </v-tooltip>
                    </router-link>
                </v-container>
            </template>
        </v-data-table>
        <response-dialog
          :model="responseDialog"
          :type="responseType"
          :message="responseMessage"
          @close="responseDialog = false"
        />
    </v-card>
</template>

<script>

import moment from "moment/moment";
import ResponseDialog from "../../components/Dialog/ResponseDialog.vue";

export default {
    name: 'NewHotelsList',
  components: {ResponseDialog},
    data: () => ({
        items: [],
        headers: [
            {text: 'Nome', value: 'name'},
            {text: 'Cidade', value: 'city'},
            {text: 'Estado', value: 'state', sortable: false},
            {text: 'Cadastrado Em', value: 'created_at'},
            {text: 'Atualizado Em', value: 'updated_at', sortable: false},
            {text: 'Ações', value: 'actions', sortable: false},
        ],
        total: 0,
        loading: false,
        options: {
            active: false,
            sortDesc: [true],
        },
        hotelName: '',
        hotelCity: '',
        hotelState: '',
        date: '',
        dateCalendar: [],
        created_at: '',
        until: '',
        responseDialog: false,
        responseMessage: '',
        responseType: '',
        cnpjValidateLoading: false,
    }),
    methods: {
        getData() {
            this.loading = true;
            const {sortBy, sortDesc, page, itemsPerPage, active} = this.options;
            const query = `&active=${active}&sort=${sortBy}&sortDesc=${sortDesc}&page=${page}&perPage=${itemsPerPage}&hotelName=${this.hotelName}&hotelCity=${this.hotelCity}&hotelState=${this.hotelState}&created_at=${this.created_at}&until=${this.until}`;
            this.$router.push({
                query: {
                    sort: sortBy,
                    sortDesc: sortDesc,
                    page: page,
                    perPage: itemsPerPage,
                    hotelName: this.hotelName,
                    hotelCity: this.hotelCity,
                    created_at: this.created_at,
                    until: this.until,
                    active: active,
                }
            });

            axios.get(`api/hotel/pending-approval-list?${query}`)
                .then(res => {
                    this.items = res.data.data;
                    this.total = res.data.total;
                    this.loading = false;
                });
        },
        parseDate(date, format) {
            return moment(date).format(format);
        },
        getLastUpdateDate(item) {
            if (item.update_histories[0]) {
                let lastUpdateDate = item.update_histories[0].action_date;
                return this.parseDate(lastUpdateDate, 'DD/MM/YYYY H:mm');
            }
            return this.parseDate(item.created_at, 'DD/MM/YYYY H:mm');
        },
        formatDate(dateCalendar) {
            if (!dateCalendar) return null

            const [year, month, day] = dateCalendar.split('-')
            return `${day}/${month}/${year}`
        },
        getCleanFilter() {
            this.$router.replace({'query': null});
            window.location.reload();
        },
        validateHotelCnpj(item) {
            if (!this.canValidateCnpj) {
                this.responseType = 'error';
                this.responseMessage = 'Você não possui permissão para validar CNPJ.';
                this.responseDialog = true;
                return;
            }
            this.$set(item, 'loading', true);
            axios.post(`/api/hotel/${item.id}/validate-cnpj`)
                .then((res) => {
                    this.responseType = 'success';
                    this.responseMessage = res.data.message;
                    this.responseDialog = true;
                }).catch((err) => {
                    this.responseType = 'error';
                    this.responseMessage = err.response.data.message;
                    this.responseDialog = true;
                }).finally(() => {
                    this.$set(item, 'loading', false);
                });
        }
    },
    watch: {
        options: {
            handler() {
                this.getData()
            },
            deep: true,
        },
        dateCalendar() {
            let created_at = this.formatDate(this.dateCalendar[0])
            if (this.dateCalendar[1] != null) {
                let until = this.formatDate(this.dateCalendar[1])
                this.date = created_at + " ate " + until
                this.created_at = this.dateCalendar[0]
                this.until = this.dateCalendar[1]
            }
        },
    },
    computed: {
        canValidateCnpj () {
            return this.$can('validate.cnpj');
        }
    }
}
</script>
<style scoped lang="scss">
:deep(.dataTable) {
    label, input {
        font-size: 14px !important;
    }
}
</style>
